import {
  Component,
  computed,
  effect,
  inject,
  input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  viewChild,
} from '@angular/core';
import { Media } from '@app/models/media.model';
import { BreadcrumbComponent } from '@app/components/breadcrumb/breadcrumb.component';
import { HeroTextComponent } from '@app/components/hero-text/hero-text.component';
import { MediaComponent } from '@app/components/media/media.component';
import { BreakpointService } from '@app/services/breakpoint.service';
import { ParagraphPgPnav } from '@app/models/paragraph.model';
import { Rating, Url } from '@app/models/entity.model';
import { StarRatingComponent } from '@app/components/star-rating/star-rating.component';
import { ComponentSharedModule } from '@app/modules/component.shared.module';
import { IconCtaComponent } from '@app/components/icon-cta/icon-cta.component';
import { PrerolloutOverlayComponent } from '@app/components/product/prerollout-overlay/prerollout-overlay.component';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { isPlatformServer } from '@angular/common';
import { Subject } from 'rxjs';

@Component({
  selector: 'mobi-product-hero',
  templateUrl: './product-hero.component.html',
  styleUrls: ['./product-hero.component.scss'],
  imports: [
    BreadcrumbComponent,
    HeroTextComponent,
    MediaComponent,
    StarRatingComponent,
    ComponentSharedModule,
    IconCtaComponent,
    PrerolloutOverlayComponent,
    MobiUiIconComponent,
  ],
  standalone: true,
})
export class ProductHeroComponent implements OnInit, OnDestroy {
  readonly headerImage = input<Media>();
  readonly headerImageMobile = input<Media>();
  readonly lead = input<string>();
  readonly title = input.required<string>();
  readonly subtitle = input<string>();
  readonly superTitle = input<string>();
  readonly contentLinks = input<ParagraphPgPnav[]>();
  readonly rating = input<Rating>();
  readonly isProtektaProduct = input(false);

  readonly hasOverview = input(true);
  readonly overviewTitle = input<string>();
  readonly overviewCta1 = input<Url>();
  readonly overviewCta2 = input<Url>();
  readonly consultationCta = input<Url>();
  readonly consultationCtaTitle = input<string>();
  readonly calculatorCta = input<Url>();
  readonly calculatorCtaTitle = input<string>();
  readonly calculatorCtaPrer = input<Url>();
  readonly nodeId = input<string>();

  readonly prerolloutOverlay = viewChild<PrerolloutOverlayComponent>('prerolloutOverlay');

  /** Whether the prerollout check overlay should be shown instead of direct navigation */
  readonly hasPrerollout = computed(() =>
    Boolean(this.calculatorCtaPrer() && this.nodeId())
  );

  #platformId = inject(PLATFORM_ID);
  #destroy$ = new Subject<void>();

  otherLinks = computed<Url[]>(() => {
    const links: Url[] = [];
    if (this.overviewCta1()) links.push(this.overviewCta1()!);
    if (this.overviewCta2()) links.push(this.overviewCta2()!);
    return links;
  });

  spacingEffect = effect(() => {
    if (isPlatformServer(this.#platformId)) return;
  });

  oneCta = computed(() => {
    return (
      (this.consultationCta() && !this.calculatorCta()) ||
      (!this.consultationCta() && this.calculatorCta())
    );
  });

  breakpoint = inject(BreakpointService);

  starSize = computed(() => {
    if (this.breakpoint.mdAndLarger()) {
      return 6;
    } else {
      return 4;
    }
  });

  ngOnInit(): void {
    if (isPlatformServer(this.#platformId)) return;
  }

  ngOnDestroy(): void {
    this.#destroy$.next();
    this.#destroy$.complete();
  }

  onCalculatorCtaClick(event: MouseEvent): void {
    if (this.hasPrerollout()) {
      event.preventDefault();
      event.stopPropagation();
      this.prerolloutOverlay()?.openOverlay();
    }
  }
}
